import styled from 'styled-components'

export const AccessoriesDescriptionWrap = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.brand};
  margin: 0 0 4rem;
`
